module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1021-18f193cd972e03bfdea09497bc31fa40.png";